// extracted by mini-css-extract-plugin
module.exports = {"filtersSubmitButton":"Vr7xRi","loading":"iNLpwI"};